<template>
  <div class="quiz-question">
    <div class="quiz-question__avatar">
      <img :src="question.avatar || defaultAvatar">
    </div>
    <div class="quiz-question__content">
      <h2 class="quiz-question__title" v-html="question.question_text"></h2>

      <!-- Слайдер эмоций для emotion_recognition типа -->
      <div
        v-if="question.type === 'emotion_recognition' && question.emotions"
        class="swiper quiz-question__slider"
        ref="emotionSlider"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(emotion, index) in question.emotions"
            :key="index"
            class="swiper-slide"
          >
            <picture>
              <source :srcset="emotion.imageWebp" type="image/webp" v-if="emotion.imageWebp">
              <img :src="emotion.image" :alt="`Эмоция ${index + 1}`">
            </picture>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>

      <!-- Обычное изображение для других типов вопросов -->
      <div v-else-if="question.image" class="quiz-question__img">
        <picture>
          <source :srcset="question.imageWebp" type="image/webp" v-if="question.imageWebp">
          <img :src="question.image" :alt="question.question_text">
        </picture>
        
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'QuizQuestion',
  props: {
    question: {
      type: Object,
      required: true,
      default: () => ({
        avatar: '',
        question_text: '',
        image: '',
        questionImage: '',
        type: '',
        emotions: []
      })
    }
  },

  data() {
    return {
      swiper: null,
      currentSlideIndex: 0,
      defaultAvatar: '/static/img/avatar/default.png'
    }
  },

  mounted() {
    // Добавляем небольшую задержку для правильной инициализации DOM
    setTimeout(() => {
      this.initSwiper()
    }, 100)
  },

  beforeUnmount() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
  },

  methods: {
    initSwiper() {
      if (this.question.type === 'emotion_recognition' && this.question.emotions && this.$refs.emotionSlider) {

        this.swiper = new Swiper(this.$refs.emotionSlider, {
          modules: [Pagination],
          allowTouchMove: false, // Отключаем ручное перелистывание
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: '.swiper-pagination',
            clickable: false // Отключаем возможность кликать по точкам пагинации
          },
          on: {
            slideChange: (swiper) => {
              this.currentSlideIndex = swiper.activeIndex
              // Эмитируем событие для родительского компонента
              this.$emit('emotion-slide-changed', swiper.activeIndex)
            }
          }
        })
      }
    },

    // Метод для программного переключения слайдов
          setSlide(index) {
        if (this.swiper && index >= 0 && index < this.question.emotions?.length) {
        this.swiper.slideTo(index)
      }
    }
  },

  watch: {
    'question.type': {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initSwiper()
          }, 100)
        })
      }
    },

    'question.emotions': {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initSwiper()
          }, 100)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.quiz-question {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 73px 24px 16px 24px;
  background-color: var(--white);
  border-radius: 32px;

  &__avatar {
    position: absolute;
    top: calc(-117px / 2);
    left: 50%;
    display: flex;
    width: 117px;
    height: 117px;
    border-radius: 92px;
    border: 7px solid #E82439;

    background: var(--white);
    transform: translateX(-50%);
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 279px;

    @media (min-width: $md) {
      max-width: 578px;
    }
  }

  &__title {
    @include question;

    margin-bottom: 24px;
  }

  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 295px;
    overflow: hidden;
    border-radius: 16px;
    aspect-ratio: 3 / 2;

    @media (min-width: $sm) {
      width: 340px;
    }

    & img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }

    & picture {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
